import LearningPathCardRenderer from '../LearningPathCardRenderer'
import { createUseStyles } from 'react-jss'
import style from './style'

const useStyle = createUseStyles(style)

export default ({
  loading,
  loadingCount = 4,
  learningPaths = [],
  columnGap = 44,
  columnDesktopGap = 44,
  tabletColumnGap = 24,
  mobileColumnGap = 0,
  rowGap = 24,
  rowDesktopGap = 24,
  tabletRowGap = 24,
  mobileRowGap = 24,
  columnCount = 4,
  columnDesktopCount = 4,
  tabletColumnCount = 2,
  mobileColumnCount = 1,
  containerMarginBottom = 64,
  containerMarginBottomTablet = 32,
  containerMarginBottomMobile = 32,
  showLoadingMore
}) => {
  const width = `calc((100% / ${columnCount}) - ((${columnGap}px * ${columnCount - 1}) / ${columnCount}))`
  const desktopWidth = `calc((100% / ${columnDesktopCount}) - ((${columnDesktopGap}px * ${columnDesktopCount - 1}) / ${columnDesktopCount}))`
  const tabletWidth = `calc((100% / ${tabletColumnCount}) - ((${tabletColumnGap}px * ${tabletColumnCount - 1}) / ${tabletColumnCount}))`
  const mobileWidth = `calc((100% / ${mobileColumnCount}) - ((${mobileColumnGap}px * ${mobileColumnCount - 1}) / ${mobileColumnCount}))`
  const loadingLearningPaths = [...Array(loadingCount)].map(_ => ({ loading: true }))
  const { container } = useStyle({
    containerMarginBottom,
    containerMarginBottomTablet,
    containerMarginBottomMobile,
    rowGap,
    rowDesktopGap,
    tabletRowGap,
    mobileRowGap,
    columnGap,
    columnDesktopGap,
    tabletColumnGap,
    mobileColumnGap
  })
  return (
    <div className={container}>
      {
        (!showLoadingMore && loading ? loadingLearningPaths : learningPaths).map(learningPath => (
          <LearningPathCardRenderer
            learningPath={learningPath}
            key={learningPath.Id}
            loading={!showLoadingMore && loading}
            width={width}
            desktopWidth={desktopWidth}
            tabletWidth={tabletWidth}
            mobileWidth={mobileWidth}
          />
        ))
      }
      {
        showLoadingMore && loading
          ? loadingLearningPaths.map((learningPath, index) => (
            <LearningPathCardRenderer
              key={`learningPathloading-${index}`}
              loading={loading}
              width={width}
              desktopWidth={desktopWidth}
              tabletWidth={tabletWidth}
              mobileWidth={mobileWidth}
            />
            ))
          : null
      }
    </div>
  )
}
